import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { jwtDecode } from "jwt-decode";

type AuthGuardProps = {
  children: ReactNode;
};

interface DecodedToken {
  exp: number;
  [key: string]: any;
}

const isTokenExpired = (token: string): boolean => {
  try {
    const decodedToken: DecodedToken = jwtDecode(token);
    const currentTime: number = Math.floor(Date.now() / 1000);
    return decodedToken.exp < currentTime;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return true;
  }
};

const clearUserFromLocalStorage = () => {
  if (localStorage.getItem("user")) {
    localStorage.removeItem("user");
  }
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { user } = useSelector((state: RootState) => state.authentication);
  const { pathname } = useLocation();

  const isAuthenticated = !!user && !isTokenExpired(user.accessToken);

  if (!isAuthenticated) {
    clearUserFromLocalStorage();
    return <Navigate replace to="/authentication/login" state={{ from: pathname }} />;
  }

  return <>{children}</>;
}